import React from "react";
import { Box, Button, Container, Stack } from "@mui/material";
import Link from "next/link";
import SectionTitle from "./SectionTitle";
import generateConfig from "../../util/config";

export default function ContactSection() {
  const config = generateConfig();
  const contactEmail = config.contactEmail;
  return (
    <Box
      component="section"
      py={12}
      sx={{
        background: (theme) =>
          `radial-gradient(circle at top, ${theme.palette.secondary.main}33, transparent 55%), ${theme.palette.background.default}`,
      }}
    >
      <Container>
        <SectionTitle
          eyebrow="Let&apos;s talk"
          title="Ready to elevate your product experience?"
          subtitle="Whether you need a polished landing page, a robust design system, or a conversational AI touchpoint, I can help plan and build it."
        />
        <Stack
          direction={{ xs: "column", md: "row" }}
          spacing={3}
          alignItems="center"
          justifyContent="center"
        >
          <Button
            component={Link}
            href="/contact"
            variant="contained"
            size="large"
            sx={{
              px: 5,
              py: 1.8,
              borderRadius: "999px",
              fontWeight: 600,
            }}
          >
            Start a project conversation
          </Button>
          <Button
            component={Link}
            href={`mailto:${contactEmail}`}
            variant="text"
            size="large"
            sx={{ fontWeight: 600 }}
          >
            {contactEmail}
          </Button>
        </Stack>
      </Container>
    </Box>
  );
}
